// Example: To understand how it works
import { ActionContext, ActionTree } from 'vuex';
import {
    SET_COMPANY_DATA,
    SET_MEMBER_CURRENT_LOCATION,
    SET_MEMBER_METROPOLITAN_AREAS,
    SET_METROPOLITAN_AREAS,
    SET_EVENT_TYPES,
    SET_SUBTYPE_OPPORTUNITIES_LIST,
    SET_MEMBER_LOCATIONS,
    SET_COMPANY_NETWORK,
    SET_SCHOOL_NETWORK,
    SET_NONPROFIT_NETWORK,
    SET_MEMBER_NETWORK,
    SET_CAUSES_DATA,
    SET_MEMBER_GENERAL_INFORMATION,
    SET_MEMBER_PROFILE_DATA,
    SET_PHILANTHROPY_DATA,
    ADD_PHILANTHROPY_DATA,
    GET_SHORTLISTED_OPPORTUNITY,
    EDIT_COMPANY_DATA,
    ADD_COMPANY_DATA,
    EDIT_SCHOOL_DATA,
    ADD_SCHOOL_DATA,

} from './mutation-types';
import State from './state';
import RootState from '../../state'
import commonApiRemote from "../../../services/commonApiRemote";
import MemberProfileService from '../../../services/memberProfileService';
import NonprofitProfileService from '../../../services/nonprofitProfileService';
import appWebConfig from '../../../../../../app.web.config';
import { MemberProfile } from '../../../models/classes/memberProfile'
import { IMemberProfile } from '../../../models/interfaces/iMemberProfile'
import humps = require('humps');
import { IGetMemberProfileDataOutput } from "../../../models/interfaces/memberProfile/iGetMemberProfileDataOutput";
import { GetMemberProfileDataOutput } from "../../../models/classes/memberProfile/getMemberProfileDataOutput";
import { GeneralInfoOfMember } from "../../../models/classes/generalInfoOfMember";
import { DefaultMemberProfileData } from "../../../models/classes/memberProfile/defaultMemberProfileData";
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { IAddEditLocationsOutput } from '../../../models/interfaces/iAddEditLocationOutput';
import { INetwork } from "../../../models/interfaces/iNetwork";
import { MemberProfileNetwork } from "../../../models/classes/memberProfile/memberProfileNetwork";
import { GetEventsOutput } from '../../../models/classes/getEventsOutput';
import { ICause } from "../../../models/interfaces/iCause";
import { IAboutMe } from "../../../models/interfaces/iAboutMe";
import { ISchool } from '../../../models/interfaces/ISchool';
import { ICompany } from '../../../models/interfaces/iCompany';
import { IQuote } from '../../../models/interfaces/iQuote';
import { IPhilanthropy } from "../../../models/interfaces/IPhilanthropy";
import { ISetFavoritesResponse } from "../../../models/interfaces/iSetFavoritesResponse";
import { IFan } from "../../../models/interfaces/iFan";
import { Fan } from "../../../models/classes/fan";
import { ICompanyEditAddOutput } from "../../../models/interfaces/memberProfile/iCompanyEditAddOutput";
import nonprofitProfileService from '../../../services/nonprofitProfileService';
const eventsNamespace: string = 'events/';
const upcomingEventsAction: string = eventsNamespace + 'getUpcomingEventsData';

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {
    getMemberProfileData({ commit, state }: ActionContext<State, RootState>, key: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const postData: IGetMemberProfileDataOutput = new GetMemberProfileDataOutput(key);
            const onLoadDefaultData: IMemberProfile = new DefaultMemberProfileData();

            await commit(SET_MEMBER_PROFILE_DATA, onLoadDefaultData);

            MemberProfileService.memberProfileData(postData).then((rsp: any) => {
                const memberProfileData = camelizer.convert(rsp.data.member);

                commit(SET_MEMBER_PROFILE_DATA, memberProfileData);
                resolve(rsp.data.member)

            }).catch((error: any) => reject(error));
        })
    },

    editWorkExperience({ commit }: ActionContext<State, RootState>, companyEditAddOutput: ICompanyEditAddOutput): Promise<any> {
        return new Promise((resolve, reject) => {
            let deleteExperienseByMemberOrgKeyPromise: Promise<any>[] = [];

            // This code isn't right all this operations must be in one transaction.
            //We have to delete roles in database no by cycle on front end.
            if (companyEditAddOutput.rolesForDeletion.length != 0) {

                companyEditAddOutput.rolesForDeletion.forEach(function (role) {
                    deleteExperienseByMemberOrgKeyPromise.push(new Promise(async (resolve, reject) => {
                        MemberProfileService.deleteExperienseByMemberOrgKey(role.memberOrgKey).then((rsp) =>
                            resolve(true))
                    }));
                })
            }

            Promise.all(deleteExperienseByMemberOrgKeyPromise).then(values => {
                //We have to delete roles in database no by cycle on front end.
                MemberProfileService.editAddWorkExperience(companyEditAddOutput).then((rsp: any) => {
                    const camelizedData = camelizer.convert(rsp) as any;
                    // console.log("after => ", camelizedData);
                    // camelizedData.org.keyBeforeUpdate = companyEditAddOutput.org.keyBeforeUpdate;
                    // debugger;
                    commit(SET_COMPANY_DATA, camelizedData.companies);
                    resolve(camelizedData);
                });
            });

        });
    },

    addWorkExperience({ commit }: ActionContext<State, RootState>, companyEditAddOutput: ICompanyEditAddOutput): Promise<any> {
        return new Promise((resolve, reject) => {
            let deleteExperienseByMemberOrgKeyPromise: Promise<any>[] = [];

            // This code isn't right all this operations must be in one transaction.
            //We have to delete roles in database no by cycle on front end.
            if (companyEditAddOutput.rolesForDeletion.length != 0) {

                companyEditAddOutput.rolesForDeletion.forEach(function (role) {
                    deleteExperienseByMemberOrgKeyPromise.push(new Promise(async (resolve, reject) => {
                        MemberProfileService.deleteExperienseByMemberOrgKey(role.memberOrgKey).then((rsp) =>
                            resolve(true))
                    }));
                })
            }

            Promise.all(deleteExperienseByMemberOrgKeyPromise).then(values => {
                //We have to delete roles in database no by cycle on front end.
                MemberProfileService.editAddWorkExperience(companyEditAddOutput).then((rsp: any) => {
                    const camelizedData = camelizer.convert(rsp) as any;
                    commit(SET_COMPANY_DATA, camelizedData.companies);
                    // commit(ADD_COMPANY_DATA, camelizedData);
                    resolve(camelizedData);
                });
            });
        });
    },

    editSchoolExperience({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.editAddSchoolExperience(data).then((rsp: any) => {
                const camelizedData = camelizer.convert(rsp) as ISchool;
                camelizedData.org.keyBeforeUpdate = data.org.keyBeforeUpdate;
                commit(EDIT_SCHOOL_DATA, camelizedData);
                resolve(camelizedData);
            });
        });
    },

    addSchoolExperience({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.editAddSchoolExperience(data).then((rsp: any) => {
                const camelizedData = camelizer.convert(rsp) as ISchool;
                commit(ADD_SCHOOL_DATA, camelizedData);
                resolve(camelizedData);
            });
        });
    },

    getMemberFandomNonprofits({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.getMemberFandomNonprofits(data).then((rsp: any) => {
                const camelizedData = camelizer.convert(rsp.data);
                resolve(camelizedData);
            });
        });
    },
    getMemberShortlistedOpportunities({ commit }: ActionContext<State, RootState>): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.getMemberShortlistedOpportunities().then((rsp: any) => {
                const camelizedData = camelizer.convert(rsp.data);
                commit(GET_SHORTLISTED_OPPORTUNITY, camelizedData);
                resolve(camelizedData);
            });
        });
    },

    setMemberNetwork({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.getMemberNetwork(data).then((rsp: any) => {
                let network: INetwork = new MemberProfileNetwork(rsp.data.companyMembers.members,
                    rsp.data.nonprofitMembers.members, rsp.data.schoolMembers.members);
                commit(SET_MEMBER_NETWORK, network);
                resolve(rsp.data);
            });
        });
    },

    setCompanyNetwork({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.getMemberNetwork(data).then((rsp: any) => {
                const camelizedData = camelizer.convert(rsp.data.members);
                commit(SET_COMPANY_NETWORK, camelizedData);
                resolve(rsp.data.nextPage);
            });
        });
    },

    setSchoolNetwork({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.getMemberNetwork(data).then((rsp: any) => {
                const camelizedData = camelizer.convert(rsp.data.members);
                commit(SET_SCHOOL_NETWORK, camelizedData);
                resolve(rsp.data.nextPage);
            });
        });
    },

    setNonprofitNetwork({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            MemberProfileService.getMemberNetwork(data).then((rsp: any) => {
                const camelizedData = camelizer.convert(rsp.data.members);
                commit(SET_NONPROFIT_NETWORK, camelizedData);
                resolve(rsp.data.nextPage);
            });
        });
    },
    changeCauses({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {

            MemberProfileService.changeCauses(data).then((rsp: any) => {

                const changedCauses: ICause[] = <ICause[]>camelizer.convert(rsp.data.causes);
                commit(SET_CAUSES_DATA, changedCauses)
            })
        });
    },

    getMemberLocations({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {

            MemberProfileService.getMemberLocations().then((rsp: any) => {
                const camelizedData: any = camelizer.convert(rsp.data)
                commit(SET_MEMBER_LOCATIONS, camelizedData.locations);

                resolve(camelizedData);
            });
        });
    },

    getMemberMetropolitanAreas({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {

            MemberProfileService.getMemberMetropolitanAreas().then((rsp: any) => {
                const camelizedData: any = camelizer.convert(rsp.data)

                commit(SET_MEMBER_METROPOLITAN_AREAS, camelizedData.metropolitanAreas);

                resolve(camelizedData);
            });
        });
    },
    getMetropolitanAreas({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {

            MemberProfileService.getMetropolitanAreas().then((rsp: any) => {
                const camelizedData: any = camelizer.convert(rsp.data)

                commit(SET_METROPOLITAN_AREAS, camelizedData.metropolitanAreas);

                resolve(camelizedData);
            });
        });
    },

    getEventTypes({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {

            NonprofitProfileService.getEventTypes().then((rsp: any) => {
                const camelizedData: any = camelizer.convert(rsp.data.map((item: any) => { return { key: item.eventtypeid, name: item.eventtypename } }))

                commit(SET_EVENT_TYPES, camelizedData);

                resolve(camelizedData);
            });
        });
    },

    getSybtypeList({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {

        return new Promise((resolve, reject) => {

            nonprofitProfileService.getSubtypeFunnelListForSearch().then((rsp: any) => {
                console.log('response subtype', rsp)
                const camelizedData: any = camelizer.convert(rsp.data.map((item: any) => {
                    return {
                        key: item.subtypeid,
                        name: item.subtypename,
                        funnelKey: item.funnelid,
                        funnelName: item.funnelname,
                        description: item.description,
                        funnelDescription: item.funneldescription
                    }
                }))

                commit(SET_SUBTYPE_OPPORTUNITIES_LIST, camelizedData);

                resolve(camelizedData);
            });
        });
    },

    // getFunnelAndSubTypeList({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {

    //     return new Promise((resolve, reject) => {

    //         nonprofitProfileService.getSubtypeFunnelListForSearch().then((rsp: any) => {
    //             console.log('response subtype', rsp)
    //             // Create a Map to store unique funnels by funnelid
    //             const uniqueFunnelsMap = new Map();

    //             // Process the response data to extract subtype list and unique funnel list
    //             const subtypeList = rsp.data.map((item: any) => {
    //                 if (!uniqueFunnelsMap.has(item.funnelid)) {
    //                     uniqueFunnelsMap.set(item.funnelid, {
    //                         funnelid: item.funnelid,
    //                         funnelname: item.funnelname,
    //                     });
    //                 }
    //                 return { key: item.subtypeid, name: item.subtypename };
    //             });

    //             // Convert Map values to an array for unique funnels
    //             const funnellist = Array.from(uniqueFunnelsMap.values());

    //             // Optionally camelize data if needed
    //             const camelizedSubtypeList = camelizer.convert(subtypeList);
    //             const camelizedFunnelList = camelizer.convert(funnellist);

    //             // Commit both lists to the store
    //             commit(SET_SUBTYPE_OPPORTUNITIES_LIST, camelizedSubtypeList);
    //             commit(SET_FUNNEL_LIST, camelizedFunnelList);

    //             // Resolve with both lists
    //             resolve({ subtypeList: camelizedSubtypeList, funnellist: camelizedFunnelList });
    //         });
    //     });
    // },

    getMemberGeneralInformation({ commit }: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {

            MemberProfileService.getMemberGeneralInformation().then((rsp: any) => {
                let memberGeneralInfo: any = camelizer.convert(rsp.data)
                commit(SET_MEMBER_GENERAL_INFORMATION, memberGeneralInfo);
                //debugger;
                resolve(memberGeneralInfo);
            });
        });
    },

    setMemberCurrentLocation({ commit, dispatch }: ActionContext<State, RootState>, data: string) {
        return new Promise((resolve, reject) => {
            MemberProfileService.setMemberCurrentLocation(data).then((rsp: any) => {
                const eventsOutput = new GetEventsOutput({
                    orgKey: '',
                    eventType: 'All',
                    isAts: false,
                });

                commit(SET_MEMBER_CURRENT_LOCATION, data);
                dispatch(upcomingEventsAction, eventsOutput, { root: true });
                resolve(rsp.data);
            });
        });
    },

    setMemberLocations({ commit, dispatch }: ActionContext<State, RootState>, data: IAddEditLocationsOutput) {
        return new Promise((resolve, reject) => {
            MemberProfileService.setMemberLocations(data).then((rsp: any) => {
                const locations = camelizer.convert(rsp.data.locations);
                const eventsOutput = new GetEventsOutput({
                    orgKey: '',
                    eventType: 'All',
                    isAts: false,
                });

                commit(SET_MEMBER_LOCATIONS, locations);
                dispatch(upcomingEventsAction, eventsOutput, { root: true });
                resolve(rsp.data);
            });
        });
    },

    updateAboutMe({ commit, dispatch }: ActionContext<State, RootState>, aboutMeData: IAboutMe) {
        commit(SET_MEMBER_GENERAL_INFORMATION, aboutMeData);
    },

    updateQuote({ commit, dispatch }: ActionContext<State, RootState>, quoteData: IQuote) {
        commit(SET_MEMBER_GENERAL_INFORMATION, quoteData);
    },

    updatePhilanthropyExperience({ commit, dispatch }: ActionContext<State, RootState>, philanthropyData: IPhilanthropy) {
        commit(SET_PHILANTHROPY_DATA, philanthropyData);
    },

    addPhilanthropyExperience({ commit, dispatch }: ActionContext<State, RootState>, philanthropyData: IPhilanthropy) {
        commit(ADD_PHILANTHROPY_DATA, philanthropyData);
    },

    setFavorites({ commit }: ActionContext<State, RootState>, orgKey: string): Promise<any> {
        return new Promise((resolve, reject) => {
            NonprofitProfileService.setFavorites(orgKey)
                .then((res: any) => {
                    const data = <ISetFavoritesResponse>camelizer.convert(res.data);
                    const fan: IFan = new Fan({ isFan: data.isFan, orgKey: data.orgKey });
                    resolve(fan);
                })
                .catch((error: any) => reject(error));
        });
    },
};

export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/member/actions.ts